<div class="clear"></div>
<a id="availability"></a>

<div class="calendar-slider-block white-block shadow-block mb-3">
  <div class="head">
    <h4>
      <strong>{{ title }} Availability:</strong>
    </h4>
    <a href="#" class="more-available-dates-header" (click)="$event.preventDefault()">
      More Available Dates <span class="icon ib-calender"></span>
    </a>
  </div>
  <div class="week-wrap calendar-slider calendar-slider-in-order">
    <div class="nav">
      <span class="left cursor-pointer" (click)="prevWeek()">
        <span class="icon ib-angle-left"></span>
      </span>
      <span class="right cursor-pointer" (click)="nextWeek()">
        <span class="icon ib-angle-right"></span>
      </span>
    </div>
    <div class="frame horizontal" id="basic">
      <ul>
        @for (day of weekDays; track day.key) {
          <li class="it" [class.has-ticket]="day.available" [attr.data-date]="day.key">
            <div class="date">{{ day.monthDay }}</div>
            <div class="w">{{ day.weekday }}</div>
            @if (day.available) {
              <a
                class="show-over-info tag"
                [class.tag-discount]="day.discounted"
                [class.active]="selectedKey === day.key"
                href="#"
                (click)="selectDay($event, day)"
                >{{ day.time }}</a
              >
            } @else {
              <div class="tag">N/A</div>
            }
          </li>
        }
      </ul>
    </div>
  </div>
  <div id="order-form-container" class="order-form-container">
    <div class="order-form-container-empty">
      <span class="icon ib-clock"></span>
      <div class="message-empty">Select time session above<br />to book tickets.</div>
    </div>
  </div>
</div>
